import { DEFAULT_DECIMALS, WEIGHT_DECIMALS } from '@/utils/number';

export const testBillingCsvDescription ='Use the same format as billing report CSVs. Columns:';

export const testBillingCsvColumns = [
  { name: 'location', required: true },
  { name: 'service_level', required: true },
  { name: 'order_id', required: true },
  { name: 'brand', required: true },
  { name: 'description' },
  { name: 'shipment_date', required: true },
  { name: 'created_date' },
  { name: 'qty' },
  { name: 'tracking_ids' },
  { name: 'ca1' },
  { name: 'total_price' },
  { name: 'zip', required: true },
  { name: 'length' },
  { name: 'width' },
  { name: 'height' },
  { name: 'scale_weight' },
];

// Same column names and order as BillingRowResult's @CsvBindByName/@CsvBindByPosition; decision paths are excluded.
export const testBillingResultCsvColumns = [
  { field: 'reportId', header: 'REPORT_ID' },
  { field: 'location', header: 'LOCATION' },
  { field: 'serviceLevel', header: 'SERVICE_LEVEL' },
  { field: 'orderId', header: 'ORDER_ID' },
  { field: 'brand', header: 'BRAND' },
  { field: 'description', header: 'DESCRIPTION' },
  { field: 'shipmentDate', header: 'SHIPMENT_DATE' },
  { field: 'createdDate', header: 'CREATED_DATE' },
  { field: 'qty', header: 'QTY' },
  { field: 'trackingIds', header: 'TRACKING_IDS' },
  { field: 'ca1', header: 'CA1' },
  { field: 'totalPrice', header: 'TOTAL_PRICE', decimals: DEFAULT_DECIMALS },
  { field: 'zip', header: 'ZIP' },
  { field: 'length', header: 'LENGTH', decimals: DEFAULT_DECIMALS },
  { field: 'width', header: 'WIDTH', decimals: DEFAULT_DECIMALS },
  { field: 'height', header: 'HEIGHT', decimals: DEFAULT_DECIMALS },
  { field: 'scaleWeight', header: 'SCALE_WEIGHT', decimals: WEIGHT_DECIMALS },
  { field: 'shipvia', header: 'SHIPVIA' },
  { field: 'trackingCount', header: 'TRACKING_COUNT' },
  { field: 'zone', header: 'ZONE' },
  { field: 'cube', header: 'CUBE', decimals: DEFAULT_DECIMALS },
  { field: 'roundWeight', header: 'ROUND_WEIGHT', decimals: WEIGHT_DECIMALS },
  { field: 'dimWeight', header: 'DIM_WEIGHT', decimals: WEIGHT_DECIMALS },
  { field: 'roundDimWeight', header: 'ROUND_DIM_WEIGHT', decimals: WEIGHT_DECIMALS },
  { field: 'billWeight', header: 'BILL_WEIGHT', decimals: WEIGHT_DECIMALS },
  { field: 'baseDas', header: 'BASE_DAS', decimals: DEFAULT_DECIMALS },
  { field: 'baseEdas', header: 'BASE_EDAS', decimals: DEFAULT_DECIMALS },
  { field: 'baseRdas', header: 'BASE_RDAS', decimals: DEFAULT_DECIMALS },
  { field: 'baseAhs', header: 'BASE_AHS', decimals: DEFAULT_DECIMALS },
  { field: 'baseFuelFee', header: 'BASE_FUEL_FEE', decimals: DEFAULT_DECIMALS },
  { field: 'baseDeliveryFee', header: 'BASE_DELIVERY_FEE', decimals: DEFAULT_DECIMALS },
  { field: 'ocs', header: 'OCS' },
  { field: 'das', header: 'DAS', decimals: DEFAULT_DECIMALS },
  { field: 'edas', header: 'EDAS', decimals: DEFAULT_DECIMALS },
  { field: 'rdas', header: 'RDAS', decimals: DEFAULT_DECIMALS },
  { field: 'ahs', header: 'AHS', decimals: DEFAULT_DECIMALS },
  { field: 'fuelFee', header: 'FUEL_FEE', decimals: DEFAULT_DECIMALS },
  { field: 'deliveryFee', header: 'DELIVERY_FEE', decimals: DEFAULT_DECIMALS },
  { field: 'cubeException', header: 'CUBE_EXCEPTION', decimals: DEFAULT_DECIMALS },
  { field: 'dimFactor', header: 'DIM_FACTOR', decimals: DEFAULT_DECIMALS },
  { field: 'basis', header: 'BASIS' },
  { field: 'rateCard', header: 'RATE_CARD' },
  { field: 'margin', header: 'MARGIN', decimals: DEFAULT_DECIMALS },
  { field: 'baseShippingRate', header: 'BASE_SHIPPING_RATE', decimals: DEFAULT_DECIMALS },
  { field: 'shippingRate', header: 'SHIPPING_RATE', decimals: DEFAULT_DECIMALS },
  { field: 'totalShippingPrice', header: 'TOTAL_SHIPPING_PRICE', decimals: DEFAULT_DECIMALS },
  { field: 'baseSurcharges', header: 'BASE_SURCHARGES', decimals: DEFAULT_DECIMALS },
  { field: 'surcharges', header: 'SURCHARGES', decimals: DEFAULT_DECIMALS },
  { field: 'surchargesList', header: 'SURCHARGES_LIST' },
  { field: 'calculationTimestamp', header: 'CALCULATION_TIMESTAMP' },
];

export const testBillingSimplifiedCsvColumns = [
  { field: 'orderId', header: 'Order ID' },
  { field: 'serviceLevel', header: 'Service Level' },
  { field: 'shipvia', header: 'Shipvia' },
  { field: 'zone', header: 'Zone' },
  { field: 'billWeight', header: 'Bill Weight', decimals: WEIGHT_DECIMALS },
  { field: 'totalPrice', header: 'Total Price', decimals: DEFAULT_DECIMALS },
  { field: 'rateBase', header: 'Rate Base' },
  { field: 'shippingRate', header: 'Shipping Rate', decimals: DEFAULT_DECIMALS },
  { field: 'ahs', header: 'AHS', decimals: DEFAULT_DECIMALS },
  { field: 'das', header: 'DAS', decimals: DEFAULT_DECIMALS },
  { field: 'edas', header: 'EDAS', decimals: DEFAULT_DECIMALS },
  { field: 'rdas', header: 'RDAS', decimals: DEFAULT_DECIMALS },
  { field: 'fuelFee', header: 'Fuel', decimals: DEFAULT_DECIMALS },
  { field: 'deliveryFee', header: 'Delivery', decimals: DEFAULT_DECIMALS },
  { field: 'surcharges', header: 'Surcharges', decimals: DEFAULT_DECIMALS },
  { field: 'margin', header: 'Margin', decimals: DEFAULT_DECIMALS },
  { field: 'totalShippingPrice', header: 'Total Shipping Price', decimals: DEFAULT_DECIMALS },
];
